var map = {
  "./prism-rip": [
    "40998",
    "77028"
  ],
  "./prism-properties.js": [
    "45820",
    "30442"
  ],
  "./prism-nim.min.js": [
    "61663",
    "25646"
  ],
  "./prism-less.min.js": [
    "64006",
    "97343"
  ],
  "./prism-ebnf.min.js": [
    "79543",
    "91615"
  ],
  "./prism-git": [
    "79787",
    "71172"
  ],
  "./prism-antlr4.min": [
    "5527",
    "2287"
  ],
  "./prism-graphql": [
    "17117",
    "77945"
  ],
  "./prism-handlebars": [
    "70110",
    "65450"
  ],
  "./prism-actionscript.js": [
    "35249",
    "4182"
  ],
  "./prism-autohotkey.min.js": [
    "531",
    "84459"
  ],
  "./prism-markup.js": [
    "24335"
  ],
  "./prism-scss.min": [
    "9578",
    "44405"
  ],
  "./prism-scala.min.js": [
    "57239",
    "57261"
  ],
  "./prism-vala.js": [
    "30035",
    "60795"
  ],
  "./prism-ichigojam.js": [
    "77460",
    "33200"
  ],
  "./prism-n4js.min.js": [
    "50169",
    "48001"
  ],
  "./prism-phpdoc.js": [
    "26280",
    "87342"
  ],
  "./prism-sqf.min": [
    "41970",
    "78879"
  ],
  "./prism-d": [
    "58149",
    "22709"
  ],
  "./prism-batch": [
    "53292",
    "91747"
  ],
  "./prism-gherkin.min.js": [
    "19876",
    "53494"
  ],
  "./prism-tt2.min.js": [
    "89366",
    "18064"
  ],
  "./prism-yaml.min.js": [
    "28831",
    "60791"
  ],
  "./prism-elm.js": [
    "75041",
    "56203"
  ],
  "./prism-apl": [
    "18508",
    "18882"
  ],
  "./prism-nasm.js": [
    "52353",
    "88160"
  ],
  "./prism-regex.min.js": [
    "64297",
    "58354"
  ],
  "./prism-applescript": [
    "31093",
    "16512"
  ],
  "./prism-autoit.min": [
    "20021",
    "21351"
  ],
  "./prism-rest.min": [
    "22369",
    "41130"
  ],
  "./prism-markup-templating.min.js": [
    "48929",
    "92827"
  ],
  "./prism-t4-cs.js": [
    "20601",
    "93528"
  ],
  "./prism-vbnet.min.js": [
    "89588",
    "35801"
  ],
  "./prism-bash.js": [
    "57874",
    "29065"
  ],
  "./prism-excel-formula.min.js": [
    "78876",
    "64832"
  ],
  "./prism-etlua.js": [
    "79958",
    "31746"
  ],
  "./prism-n1ql.min.js": [
    "86985",
    "18285"
  ],
  "./prism-smali.min.js": [
    "51406",
    "9491"
  ],
  "./prism-lisp": [
    "45520",
    "94800"
  ],
  "./prism-json.min.js": [
    "8674",
    "88519"
  ],
  "./prism-plsql.js": [
    "92927",
    "76954"
  ],
  "./prism-stylus": [
    "24906",
    "24102"
  ],
  "./prism-etlua.min": [
    "16195",
    "91878"
  ],
  "./prism-dhall.min": [
    "87981",
    "42239"
  ],
  "./prism-r.min.js": [
    "41704",
    "31820"
  ],
  "./prism-dax.js": [
    "90827",
    "71032"
  ],
  "./prism-liquid.min.js": [
    "55728",
    "50407"
  ],
  "./prism-livescript": [
    "76347",
    "731"
  ],
  "./prism-php-extras": [
    "89425",
    "58199"
  ],
  "./prism-php.min.js": [
    "37675",
    "25078"
  ],
  "./prism-bro": [
    "76609",
    "44268"
  ],
  "./prism-dart": [
    "57065",
    "2213"
  ],
  "./prism-sass.js": [
    "89865",
    "84641"
  ],
  "./prism-cil": [
    "4677",
    "43154"
  ],
  "./prism-brightscript.min": [
    "39455",
    "71161"
  ],
  "./prism-asciidoc": [
    "19482",
    "60797"
  ],
  "./prism-jsstacktrace.js": [
    "81917",
    "4621"
  ],
  "./prism-n4js.js": [
    "88651",
    "99711"
  ],
  "./prism-groovy.js": [
    "40485",
    "80555"
  ],
  "./prism-opencl": [
    "13144",
    "42758"
  ],
  "./prism-fortran.min": [
    "70975",
    "11095"
  ],
  "./prism-reason": [
    "28439",
    "45019"
  ],
  "./prism-hpkp.js": [
    "26203",
    "68300"
  ],
  "./prism-jsonp.min.js": [
    "81286",
    "53044"
  ],
  "./prism-puppet.min.js": [
    "25834",
    "43261"
  ],
  "./prism-xml-doc.min": [
    "19883",
    "79922"
  ],
  "./prism-haxe.min.js": [
    "40714",
    "6172"
  ],
  "./prism-rust.js": [
    "70767",
    "59977"
  ],
  "./prism-eiffel.min.js": [
    "2891",
    "63966"
  ],
  "./prism-purebasic": [
    "92168",
    "32862"
  ],
  "./prism-j.min.js": [
    "78067",
    "64733"
  ],
  "./prism-qml.min": [
    "81124",
    "22849"
  ],
  "./prism-flow.js": [
    "9220",
    "68899"
  ],
  "./prism-purebasic.js": [
    "92168",
    "32862"
  ],
  "./prism-ignore.min.js": [
    "47122",
    "52364"
  ],
  "./prism-icon.min.js": [
    "45477",
    "59731"
  ],
  "./prism-rust": [
    "70767",
    "59977"
  ],
  "./prism-haml.min": [
    "53025",
    "7696"
  ],
  "./prism-ada.js": [
    "85795",
    "26617"
  ],
  "./prism-java.min.js": [
    "17706",
    "87366"
  ],
  "./prism-makefile.min.js": [
    "75151",
    "71700"
  ],
  "./prism-plsql.min": [
    "55129",
    "46519"
  ],
  "./prism-tap": [
    "46193",
    "2267"
  ],
  "./prism-jsonp": [
    "64488",
    "72886"
  ],
  "./prism-abnf.min": [
    "48121",
    "88030"
  ],
  "./prism-cil.min": [
    "54002",
    "74681"
  ],
  "./prism-turtle.min": [
    "10034",
    "21282"
  ],
  "./prism-git.min.js": [
    "93530",
    "3793"
  ],
  "./prism-opencl.js": [
    "13144",
    "42758"
  ],
  "./prism-smali.js": [
    "10509",
    "38174"
  ],
  "./prism-ruby": [
    "59385",
    "13731"
  ],
  "./prism-yaml": [
    "73358",
    "54696"
  ],
  "./prism-t4-vb.min.js": [
    "78305",
    "79060"
  ],
  "./prism-cypher.min": [
    "99860",
    "66629"
  ],
  "./prism-sqf.min.js": [
    "41970",
    "78879"
  ],
  "./prism-lilypond.min": [
    "12555",
    "39555"
  ],
  "./prism-oz.min.js": [
    "87553",
    "14158"
  ],
  "./prism-sparql.min": [
    "46811",
    "7150"
  ],
  "./prism-oz": [
    "903",
    "61422"
  ],
  "./prism-objectivec.js": [
    "11426",
    "92200"
  ],
  "./prism-julia": [
    "56543",
    "17717"
  ],
  "./prism-sqf.js": [
    "83113",
    "56719"
  ],
  "./prism-pure.min": [
    "44697",
    "89340"
  ],
  "./prism-bbcode.min": [
    "22661",
    "5917"
  ],
  "./prism-excel-formula.js": [
    "51039",
    "6672"
  ],
  "./prism-ocaml.js": [
    "24371",
    "24057"
  ],
  "./prism-hcl": [
    "24677",
    "67986"
  ],
  "./prism-python.min": [
    "29208",
    "17722"
  ],
  "./prism-julia.min.js": [
    "82580",
    "19582"
  ],
  "./prism-turtle.js": [
    "68092",
    "6756"
  ],
  "./prism-cpp.min": [
    "54132",
    "66719"
  ],
  "./prism-roboconf.min.js": [
    "33134",
    "87732"
  ],
  "./prism-scss.js": [
    "92447",
    "23549"
  ],
  "./prism-dns-zone-file.js": [
    "68483",
    "32405"
  ],
  "./prism-hcl.min": [
    "7044",
    "83561"
  ],
  "./prism-nasm.min.js": [
    "10603",
    "10077"
  ],
  "./prism-zig": [
    "857",
    "58671"
  ],
  "./prism-django.min.js": [
    "85534",
    "95717"
  ],
  "./prism-antlr4.min.js": [
    "5527",
    "2287"
  ],
  "./prism-apacheconf.min.js": [
    "24242",
    "85450"
  ],
  "./prism-racket.min.js": [
    "87382",
    "66000"
  ],
  "./prism-aql": [
    "25691",
    "55806"
  ],
  "./prism-typescript.min.js": [
    "76456",
    "99553"
  ],
  "./prism-eiffel.min": [
    "2891",
    "63966"
  ],
  "./prism-sas.js": [
    "71384",
    "73088"
  ],
  "./prism-excel-formula.min": [
    "78876",
    "64832"
  ],
  "./prism-jsonp.min": [
    "81286",
    "53044"
  ],
  "./prism-tcl": [
    "1607",
    "90410"
  ],
  "./prism-js-extras.js": [
    "46690",
    "29586"
  ],
  "./prism-flow": [
    "9220",
    "68899"
  ],
  "./prism-concurnas": [
    "29467",
    "53664"
  ],
  "./prism-fsharp.min.js": [
    "25001",
    "10363"
  ],
  "./prism-cypher.js": [
    "30258",
    "83325"
  ],
  "./prism-gml.js": [
    "71828",
    "82567"
  ],
  "./prism-jq": [
    "96342",
    "88529"
  ],
  "./prism-toml.min": [
    "30485",
    "30922"
  ],
  "./prism-perl.min": [
    "93972",
    "53008"
  ],
  "./prism-tcl.js": [
    "1607",
    "90410"
  ],
  "./prism-livescript.min.js": [
    "41163",
    "93324"
  ],
  "./prism-processing.min.js": [
    "15759",
    "88846"
  ],
  "./prism-inform7": [
    "56521",
    "21580"
  ],
  "./prism-jsdoc.js": [
    "68915",
    "52939"
  ],
  "./prism-markdown.js": [
    "24064"
  ],
  "./prism-mel.js": [
    "16185",
    "24008"
  ],
  "./prism-r": [
    "54803",
    "25073"
  ],
  "./prism-aspnet.min": [
    "54780",
    "66550"
  ],
  "./prism-antlr4.js": [
    "44852",
    "32520"
  ],
  "./prism-jsstacktrace.min": [
    "68152",
    "96705"
  ],
  "./prism-opencl.min": [
    "52818",
    "20397"
  ],
  "./prism-lolcode": [
    "26555",
    "43474"
  ],
  "./prism-firestore-security-rules.min.js": [
    "67128",
    "72583"
  ],
  "./prism-vala.min": [
    "67524",
    "68636"
  ],
  "./prism-actionscript.min.js": [
    "53896",
    "82569"
  ],
  "./prism-soy": [
    "84435",
    "58867"
  ],
  "./prism-django.min": [
    "85534",
    "95717"
  ],
  "./prism-sparql.js": [
    "71327",
    "55902"
  ],
  "./prism-aql.js": [
    "25691",
    "55806"
  ],
  "./prism-dhall": [
    "24370",
    "69480"
  ],
  "./prism-brainfuck.js": [
    "15827",
    "37929"
  ],
  "./prism-editorconfig.js": [
    "22456",
    "13744"
  ],
  "./prism-protobuf.js": [
    "37345",
    "51946"
  ],
  "./prism-qore": [
    "94933",
    "72115"
  ],
  "./prism-fsharp": [
    "75045",
    "47170"
  ],
  "./prism-less": [
    "37802",
    "12649"
  ],
  "./prism-robotframework.js": [
    "23449",
    "24700"
  ],
  "./prism-jsx.min": [
    "81233",
    "73588"
  ],
  "./prism-smalltalk.js": [
    "22738",
    "97160"
  ],
  "./prism-hpkp.min": [
    "67623",
    "54358"
  ],
  "./prism-lolcode.min.js": [
    "10076",
    "7120"
  ],
  "./prism-purebasic.min": [
    "57562",
    "56147"
  ],
  "./prism-moonscript.min.js": [
    "65298",
    "83281"
  ],
  "./prism-icon.js": [
    "54263",
    "78825"
  ],
  "./prism-javascript.min": [
    "30235",
    "99393"
  ],
  "./prism-brainfuck.min.js": [
    "99676",
    "78441"
  ],
  "./prism-clike.js": [
    "35433",
    "55728"
  ],
  "./prism-javadoclike.min.js": [
    "46847",
    "23721"
  ],
  "./prism-mizar": [
    "15101",
    "44213"
  ],
  "./prism-vhdl.js": [
    "38564",
    "60566"
  ],
  "./prism-bash": [
    "57874",
    "29065"
  ],
  "./prism-erb.js": [
    "66512",
    "26103"
  ],
  "./prism-jolie": [
    "68874",
    "61247"
  ],
  "./prism-robotframework.min": [
    "9611",
    "51331"
  ],
  "./prism-markdown": [
    "24064"
  ],
  "./prism-d.min": [
    "3525",
    "21969"
  ],
  "./prism-n4js.min": [
    "50169",
    "48001"
  ],
  "./prism-coffeescript.min.js": [
    "37271",
    "77798"
  ],
  "./prism-asciidoc.js": [
    "19482",
    "60797"
  ],
  "./prism-actionscript.min": [
    "53896",
    "82569"
  ],
  "./prism-textile.min": [
    "34966",
    "1717"
  ],
  "./prism-clojure": [
    "52812",
    "38288"
  ],
  "./prism-warpscript": [
    "10008",
    "73817"
  ],
  "./prism-crystal.min": [
    "77223",
    "18295"
  ],
  "./prism-lilypond.min.js": [
    "12555",
    "39555"
  ],
  "./prism-hcl.min.js": [
    "7044",
    "83561"
  ],
  "./prism-parigp.min.js": [
    "90575",
    "67433"
  ],
  "./prism-php": [
    "99945",
    "19450"
  ],
  "./prism-css.min": [
    "12247",
    "2677"
  ],
  "./prism-smalltalk": [
    "22738",
    "97160"
  ],
  "./prism-parser.js": [
    "40780",
    "3999"
  ],
  "./prism-markup-templating.js": [
    "96854",
    "64465"
  ],
  "./prism-peoplecode": [
    "74984",
    "13297"
  ],
  "./prism-protobuf.min.js": [
    "98250",
    "22271"
  ],
  "./prism-markup.min.js": [
    "74060",
    "89629"
  ],
  "./prism-pcaxis.min.js": [
    "55863",
    "19234"
  ],
  "./prism-objectivec": [
    "11426",
    "92200"
  ],
  "./prism-jsdoc.min": [
    "27472",
    "41607"
  ],
  "./prism-qore.min": [
    "93661",
    "32231"
  ],
  "./prism-pascaligo.js": [
    "54332",
    "32472"
  ],
  "./prism-icon.min": [
    "45477",
    "59731"
  ],
  "./prism-jsx": [
    "62356",
    "62553"
  ],
  "./prism-haskell": [
    "51797",
    "75981"
  ],
  "./prism-javascript": [
    "39980",
    "58128"
  ],
  "./prism-tap.js": [
    "46193",
    "2267"
  ],
  "./prism-kotlin": [
    "32334",
    "32657"
  ],
  "./prism-xml-doc": [
    "62349",
    "6248"
  ],
  "./prism-rust.min.js": [
    "60983",
    "44995"
  ],
  "./prism-zig.min": [
    "87975",
    "54828"
  ],
  "./prism-wasm.min.js": [
    "53994",
    "42946"
  ],
  "./prism-handlebars.js": [
    "70110",
    "65450"
  ],
  "./prism-pure.js": [
    "9753",
    "80219"
  ],
  "./prism-elixir.js": [
    "68805",
    "41693"
  ],
  "./prism-makefile": [
    "48443",
    "31442"
  ],
  "./prism-twig.min": [
    "33161",
    "59338"
  ],
  "./prism-tap.min": [
    "85599",
    "5685"
  ],
  "./prism-vim.min": [
    "34836",
    "39764"
  ],
  "./prism-firestore-security-rules.min": [
    "67128",
    "72583"
  ],
  "./prism-etlua.min.js": [
    "16195",
    "91878"
  ],
  "./prism-c": [
    "4279",
    "51387"
  ],
  "./prism-regex.min": [
    "64297",
    "58354"
  ],
  "./prism-latte": [
    "87442",
    "19690"
  ],
  "./prism-xml-doc.js": [
    "62349",
    "6248"
  ],
  "./prism-brainfuck.min": [
    "99676",
    "78441"
  ],
  "./prism-wiki": [
    "31693",
    "62995"
  ],
  "./prism-swift.min.js": [
    "39361",
    "54427"
  ],
  "./prism-json": [
    "55394",
    "33354"
  ],
  "./prism-ignore": [
    "10880",
    "23130"
  ],
  "./prism-ignore.min": [
    "47122",
    "52364"
  ],
  "./prism-aspnet": [
    "54019",
    "29723"
  ],
  "./prism-erb": [
    "66512",
    "26103"
  ],
  "./prism-bnf.min": [
    "86751",
    "39061"
  ],
  "./prism-gml.min": [
    "81813",
    "90139"
  ],
  "./prism-io.js": [
    "48942",
    "88492"
  ],
  "./prism-core": [
    "28325",
    "75123"
  ],
  "./prism-vhdl": [
    "38564",
    "60566"
  ],
  "./prism-sass.min.js": [
    "23683",
    "14693"
  ],
  "./prism-splunk-spl.min.js": [
    "34810",
    "80470"
  ],
  "./prism-factor.js": [
    "50171",
    "9429"
  ],
  "./prism-matlab": [
    "61169",
    "75513"
  ],
  "./prism-powerquery.min.js": [
    "43171",
    "2273"
  ],
  "./prism-groovy.min": [
    "29627",
    "54257"
  ],
  "./prism-iecst.min.js": [
    "17238",
    "78468"
  ],
  "./prism-kotlin.min.js": [
    "44002",
    "16267"
  ],
  "./prism-haskell.min.js": [
    "12199",
    "3321"
  ],
  "./prism-coffeescript.js": [
    "46213",
    "33754"
  ],
  "./prism-ruby.min.js": [
    "38751",
    "29003"
  ],
  "./prism-xquery.min.js": [
    "25558",
    "88907"
  ],
  "./prism-jsx.js": [
    "62356",
    "62553"
  ],
  "./prism-abnf": [
    "68758",
    "84257"
  ],
  "./prism-editorconfig.min": [
    "41880",
    "71257"
  ],
  "./prism-neon.js": [
    "77661",
    "49369"
  ],
  "./prism-javadoc.min": [
    "78792",
    "31926"
  ],
  "./prism-peoplecode.min": [
    "11025",
    "69720"
  ],
  "./prism-racket": [
    "24540",
    "24980"
  ],
  "./prism-xml-doc.min.js": [
    "19883",
    "79922"
  ],
  "./prism-xquery.js": [
    "19938",
    "95866"
  ],
  "./prism-lilypond": [
    "61719",
    "35948"
  ],
  "./prism-pascaligo.min.js": [
    "68000",
    "98536"
  ],
  "./prism-t4-cs.min.js": [
    "73233",
    "88588"
  ],
  "./prism-graphql.min": [
    "11530",
    "18878"
  ],
  "./prism-coffeescript": [
    "46213",
    "33754"
  ],
  "./prism-jolie.js": [
    "68874",
    "61247"
  ],
  "./prism-purebasic.min.js": [
    "57562",
    "56147"
  ],
  "./prism-solution-file.min": [
    "44863",
    "54871"
  ],
  "./prism-http.min": [
    "587",
    "81709"
  ],
  "./prism-velocity.min.js": [
    "76627",
    "59264"
  ],
  "./prism-jolie.min": [
    "91429",
    "93812"
  ],
  "./prism-gcode.min": [
    "9303",
    "75618"
  ],
  "./prism-clike.min": [
    "58080",
    "56975"
  ],
  "./prism-hpkp": [
    "26203",
    "68300"
  ],
  "./prism-plsql": [
    "92927",
    "76954"
  ],
  "./prism-plsql.min.js": [
    "55129",
    "46519"
  ],
  "./prism-handlebars.min.js": [
    "34329",
    "34345"
  ],
  "./prism-ichigojam": [
    "77460",
    "33200"
  ],
  "./prism-python.min.js": [
    "29208",
    "17722"
  ],
  "./prism-hlsl.js": [
    "5578",
    "96730"
  ],
  "./prism-graphql.min.js": [
    "11530",
    "18878"
  ],
  "./prism-crystal.js": [
    "18980",
    "5176"
  ],
  "./prism-bro.min": [
    "28708",
    "31145"
  ],
  "./prism-iecst": [
    "55689",
    "32442"
  ],
  "./prism-latex.js": [
    "90319",
    "12918"
  ],
  "./prism-sql.js": [
    "35266",
    "43168"
  ],
  "./prism-http.min.js": [
    "587",
    "81709"
  ],
  "./prism-typescript": [
    "96836",
    "35468"
  ],
  "./prism-scss": [
    "92447",
    "23549"
  ],
  "./prism-batch.min": [
    "65965",
    "13230"
  ],
  "./prism-robotframework": [
    "23449",
    "24700"
  ],
  "./prism-eiffel.js": [
    "59979",
    "39438"
  ],
  "./prism-gedcom.min": [
    "17065",
    "75925"
  ],
  "./prism-wasm": [
    "5774",
    "39398"
  ],
  "./prism-al.min": [
    "47347",
    "86531"
  ],
  "./prism-rip.min": [
    "44538",
    "43966"
  ],
  "./prism-haml": [
    "39181",
    "78933"
  ],
  "./prism-xojo.min.js": [
    "37315",
    "74884"
  ],
  "./prism-c.js": [
    "4279",
    "51387"
  ],
  "./prism-neon": [
    "77661",
    "49369"
  ],
  "./prism-velocity.js": [
    "70981",
    "36295"
  ],
  "./prism-fsharp.min": [
    "25001",
    "10363"
  ],
  "./prism-aql.min": [
    "29846",
    "86023"
  ],
  "./prism-arduino.js": [
    "51849",
    "18638"
  ],
  "./prism-toml.js": [
    "9930",
    "4352"
  ],
  "./prism-splunk-spl.min": [
    "34810",
    "80470"
  ],
  "./prism-verilog": [
    "47251",
    "38813"
  ],
  "./prism-ebnf.min": [
    "79543",
    "91615"
  ],
  "./prism-warpscript.min": [
    "80552",
    "54270"
  ],
  "./prism-rip.js": [
    "40998",
    "77028"
  ],
  "./prism-js-extras.min.js": [
    "49273",
    "3490"
  ],
  "./prism-rest.js": [
    "76577",
    "86763"
  ],
  "./prism-js-templates": [
    "38885",
    "13999"
  ],
  "./prism-gedcom": [
    "66857",
    "95967"
  ],
  "./prism-autoit.min.js": [
    "20021",
    "21351"
  ],
  "./prism-r.min": [
    "41704",
    "31820"
  ],
  "./prism-wasm.min": [
    "53994",
    "42946"
  ],
  "./prism-jq.min.js": [
    "92771",
    "84901"
  ],
  "./prism-bnf": [
    "24115",
    "29098"
  ],
  "./prism-asciidoc.min": [
    "55692",
    "68924"
  ],
  "./prism-phpdoc.min": [
    "49724",
    "6116"
  ],
  "./prism-roboconf.js": [
    "94840",
    "37335"
  ],
  "./prism-splunk-spl.js": [
    "612",
    "65407"
  ],
  "./prism-js-extras": [
    "46690",
    "29586"
  ],
  "./prism-renpy": [
    "38512",
    "17075"
  ],
  "./prism-jolie.min.js": [
    "91429",
    "93812"
  ],
  "./prism-ebnf.js": [
    "68232",
    "11167"
  ],
  "./prism-kotlin.min": [
    "44002",
    "16267"
  ],
  "./prism-neon.min.js": [
    "98832",
    "55789"
  ],
  "./prism-powerquery.min": [
    "43171",
    "2273"
  ],
  "./prism-sqf": [
    "83113",
    "56719"
  ],
  "./prism-lolcode.js": [
    "26555",
    "43474"
  ],
  "./prism-nim.min": [
    "61663",
    "25646"
  ],
  "./prism-t4-vb": [
    "16241",
    "85132"
  ],
  "./prism-swift.js": [
    "90874",
    "4323"
  ],
  "./prism-bro.min.js": [
    "28708",
    "31145"
  ],
  "./prism-bnf.js": [
    "24115",
    "29098"
  ],
  "./prism-docker.min": [
    "74280",
    "54018"
  ],
  "./prism-peoplecode.min.js": [
    "11025",
    "69720"
  ],
  "./prism-warpscript.min.js": [
    "80552",
    "54270"
  ],
  "./prism-coffeescript.min": [
    "37271",
    "77798"
  ],
  "./prism-ada.min.js": [
    "92497",
    "23623"
  ],
  "./prism-objectivec.min.js": [
    "51637",
    "77344"
  ],
  "./prism-core.min.js": [
    "2251",
    "32566"
  ],
  "./prism-nim": [
    "35743",
    "98182"
  ],
  "./prism-bison.js": [
    "97861",
    "62695"
  ],
  "./prism-csharp.js": [
    "79016",
    "51738"
  ],
  "./prism-bbcode.js": [
    "46428",
    "89205"
  ],
  "./prism-editorconfig": [
    "22456",
    "13744"
  ],
  "./prism-yaml.min": [
    "28831",
    "60791"
  ],
  "./prism-cypher.min.js": [
    "99860",
    "66629"
  ],
  "./prism-apl.min.js": [
    "38162",
    "35432"
  ],
  "./prism-markup": [
    "24335"
  ],
  "./prism-crystal.min.js": [
    "77223",
    "18295"
  ],
  "./prism-wiki.min": [
    "83409",
    "86860"
  ],
  "./prism-bash.min": [
    "87013",
    "9258"
  ],
  "./prism-keyman.js": [
    "82821",
    "87803"
  ],
  "./prism-racket.js": [
    "24540",
    "24980"
  ],
  "./prism-lisp.min.js": [
    "87770",
    "75322"
  ],
  "./prism-haml.min.js": [
    "53025",
    "7696"
  ],
  "./prism-nginx.js": [
    "33436",
    "63070"
  ],
  "./prism-al": [
    "42273",
    "51988"
  ],
  "./prism-zig.js": [
    "857",
    "58671"
  ],
  "./prism-js-templates.js": [
    "38885",
    "13999"
  ],
  "./prism-qml.min.js": [
    "81124",
    "22849"
  ],
  "./prism-pascal.min.js": [
    "53484",
    "40166"
  ],
  "./prism-n1ql": [
    "55949",
    "69931"
  ],
  "./prism-vbnet.js": [
    "65398",
    "2225"
  ],
  "./prism-sparql.min.js": [
    "46811",
    "7150"
  ],
  "./prism-arff.min.js": [
    "13955",
    "39120"
  ],
  "./prism-php.js": [
    "99945",
    "19450"
  ],
  "./prism-javascript.js": [
    "39980",
    "58128"
  ],
  "./prism-mizar.min.js": [
    "38654",
    "89699"
  ],
  "./prism-dns-zone-file.min": [
    "67659",
    "67666"
  ],
  "./prism-smarty": [
    "89281",
    "67922"
  ],
  "./prism-groovy.min.js": [
    "29627",
    "54257"
  ],
  "./prism-basic": [
    "94446",
    "83977"
  ],
  "./prism-textile.min.js": [
    "34966",
    "1717"
  ],
  "./prism-aspnet.js": [
    "54019",
    "29723"
  ],
  "./prism-pcaxis": [
    "52892",
    "43769"
  ],
  "./prism-ejs.min": [
    "65823",
    "5123"
  ],
  "./prism-go": [
    "27046",
    "81171"
  ],
  "./prism-autoit.js": [
    "24940",
    "11018"
  ],
  "./prism-twig.min.js": [
    "33161",
    "59338"
  ],
  "./prism-phpdoc": [
    "26280",
    "87342"
  ],
  "./prism-powershell.min.js": [
    "77424",
    "47002"
  ],
  "./prism-abap": [
    "86405",
    "54861"
  ],
  "./prism-fortran.js": [
    "27915",
    "50344"
  ],
  "./prism-monkey.min.js": [
    "7259",
    "382"
  ],
  "./prism-smarty.js": [
    "89281",
    "67922"
  ],
  "./prism-n4js": [
    "88651",
    "99711"
  ],
  "./prism-soy.js": [
    "84435",
    "58867"
  ],
  "./prism-bro.js": [
    "76609",
    "44268"
  ],
  "./prism-apl.min": [
    "38162",
    "35432"
  ],
  "./prism-solution-file": [
    "37485",
    "81711"
  ],
  "./prism-javadoclike.js": [
    "54884",
    "19205"
  ],
  "./prism-prolog.min.js": [
    "32517",
    "39544"
  ],
  "./prism-tt2": [
    "37838",
    "55613"
  ],
  "./prism-ocaml": [
    "24371",
    "24057"
  ],
  "./prism-al.js": [
    "42273",
    "51988"
  ],
  "./prism-oz.js": [
    "903",
    "61422"
  ],
  "./prism-python.js": [
    "80366",
    "86965"
  ],
  "./prism-gherkin": [
    "49472",
    "12194"
  ],
  "./prism-unrealscript.min.js": [
    "79133",
    "96072"
  ],
  "./prism-pug.js": [
    "93381",
    "66502"
  ],
  "./prism-smali": [
    "10509",
    "38174"
  ],
  "./prism-dhall.js": [
    "24370",
    "69480"
  ],
  "./prism-yang.min": [
    "6959",
    "85189"
  ],
  "./prism-puppet.min": [
    "25834",
    "43261"
  ],
  "./prism-smalltalk.min.js": [
    "64326",
    "45611"
  ],
  "./prism-gedcom.js": [
    "66857",
    "95967"
  ],
  "./prism-ada": [
    "85795",
    "26617"
  ],
  "./prism-php.min": [
    "37675",
    "25078"
  ],
  "./prism-properties": [
    "45820",
    "30442"
  ],
  "./prism-erb.min": [
    "83000",
    "52863"
  ],
  "./prism-hpkp.min.js": [
    "67623",
    "54358"
  ],
  "./prism-fortran": [
    "27915",
    "50344"
  ],
  "./prism-lua.js": [
    "66841",
    "79746"
  ],
  "./prism-stylus.min.js": [
    "72660",
    "295"
  ],
  "./prism-php-extras.js": [
    "89425",
    "58199"
  ],
  "./prism-applescript.min": [
    "39943",
    "60556"
  ],
  "./prism-ocaml.min": [
    "37610",
    "14454"
  ],
  "./prism-scala.js": [
    "12886",
    "31466"
  ],
  "./prism-scheme.min.js": [
    "25781",
    "20144"
  ],
  "./prism-jq.js": [
    "96342",
    "88529"
  ],
  "./prism-n1ql.min": [
    "86985",
    "18285"
  ],
  "./prism-flow.min.js": [
    "60758",
    "75949"
  ],
  "./prism-rest": [
    "76577",
    "86763"
  ],
  "./prism-j.min": [
    "78067",
    "64733"
  ],
  "./prism-d.min.js": [
    "3525",
    "21969"
  ],
  "./prism-css": [
    "15251",
    "94325"
  ],
  "./prism-hsts.min": [
    "23808",
    "92926"
  ],
  "./prism-json5.min": [
    "54001",
    "35908"
  ],
  "./prism-erlang.js": [
    "8956",
    "66363"
  ],
  "./prism-tt2.js": [
    "37838",
    "55613"
  ],
  "./prism-lisp.js": [
    "45520",
    "94800"
  ],
  "./prism-liquid.min": [
    "55728",
    "50407"
  ],
  "./prism-hsts.min.js": [
    "23808",
    "92926"
  ],
  "./prism-mel": [
    "16185",
    "24008"
  ],
  "./prism-javastacktrace.js": [
    "81454",
    "5848"
  ],
  "./prism-asm6502": [
    "36972",
    "29131"
  ],
  "./prism-latte.min": [
    "29908",
    "66445"
  ],
  "./prism-roboconf.min": [
    "33134",
    "87732"
  ],
  "./prism-unrealscript.js": [
    "10196",
    "23056"
  ],
  "./prism-wiki.js": [
    "31693",
    "62995"
  ],
  "./prism-python": [
    "80366",
    "86965"
  ],
  "./prism-reason.min.js": [
    "47788",
    "69307"
  ],
  "./prism-toml.min.js": [
    "30485",
    "30922"
  ],
  "./prism-latte.min.js": [
    "29908",
    "66445"
  ],
  "./prism-smalltalk.min": [
    "64326",
    "45611"
  ],
  "./prism-batch.min.js": [
    "65965",
    "13230"
  ],
  "./prism-apacheconf.js": [
    "77533",
    "97885"
  ],
  "./prism-autohotkey": [
    "92776",
    "52565"
  ],
  "./prism-yang.min.js": [
    "6959",
    "85189"
  ],
  "./prism-dart.min": [
    "80974",
    "30464"
  ],
  "./prism-shell-session.min": [
    "98863",
    "23319"
  ],
  "./prism-tcl.min": [
    "96195",
    "70330"
  ],
  "./prism-gedcom.min.js": [
    "17065",
    "75925"
  ],
  "./prism-d.js": [
    "58149",
    "22709"
  ],
  "./prism-processing.min": [
    "15759",
    "88846"
  ],
  "./prism-monkey.js": [
    "80676",
    "31551"
  ],
  "./prism-monkey": [
    "80676",
    "31551"
  ],
  "./prism-sass": [
    "89865",
    "84641"
  ],
  "./prism-vala.min.js": [
    "67524",
    "68636"
  ],
  "./prism-actionscript": [
    "35249",
    "4182"
  ],
  "./prism-elixir.min.js": [
    "43045",
    "48553"
  ],
  "./prism-autoit": [
    "24940",
    "11018"
  ],
  "./prism-dax": [
    "90827",
    "71032"
  ],
  "./prism-pascal": [
    "13210",
    "42708"
  ],
  "./prism-powershell.js": [
    "86862",
    "18687"
  ],
  "./prism-qore.min.js": [
    "93661",
    "32231"
  ],
  "./prism-shell-session.js": [
    "42963",
    "6905"
  ],
  "./prism-sql.min": [
    "82720",
    "40533"
  ],
  "./prism-scala": [
    "12886",
    "31466"
  ],
  "./prism-ftl": [
    "72778",
    "10499"
  ],
  "./prism-ini.min": [
    "19475",
    "55771"
  ],
  "./prism-parigp": [
    "47511",
    "8142"
  ],
  "./prism-parser.min.js": [
    "97410",
    "19780"
  ],
  "./prism-jsx.min.js": [
    "81233",
    "73588"
  ],
  "./prism-swift.min": [
    "39361",
    "54427"
  ],
  "./prism-haxe.js": [
    "14324",
    "45095"
  ],
  "./prism-javadoc.js": [
    "52008",
    "33595"
  ],
  "./prism-apl.js": [
    "18508",
    "18882"
  ],
  "./prism-nsis.min": [
    "68617",
    "38225"
  ],
  "./prism-ichigojam.min": [
    "54111",
    "55541"
  ],
  "./prism-io.min": [
    "93154",
    "41740"
  ],
  "./prism-keyman": [
    "82821",
    "87803"
  ],
  "./prism-ruby.min": [
    "38751",
    "29003"
  ],
  "./prism-yaml.js": [
    "73358",
    "54696"
  ],
  "./prism-clojure.js": [
    "52812",
    "38288"
  ],
  "./prism-nix": [
    "58704",
    "40229"
  ],
  "./prism-bison": [
    "97861",
    "62695"
  ],
  "./prism-liquid": [
    "150",
    "16695"
  ],
  "./prism-t4-templating.min": [
    "94413",
    "33557"
  ],
  "./prism-asm6502.js": [
    "36972",
    "29131"
  ],
  "./prism-ruby.js": [
    "59385",
    "13731"
  ],
  "./prism-keyman.min": [
    "51064",
    "22076"
  ],
  "./prism-t4-vb.min": [
    "78305",
    "79060"
  ],
  "./prism-vbnet.min": [
    "89588",
    "35801"
  ],
  "./prism-haxe": [
    "14324",
    "45095"
  ],
  "./prism-hlsl.min.js": [
    "62058",
    "91022"
  ],
  "./prism-flow.min": [
    "60758",
    "75949"
  ],
  "./prism-renpy.min": [
    "68169",
    "21303"
  ],
  "./prism-verilog.js": [
    "47251",
    "38813"
  ],
  "./prism-wasm.js": [
    "5774",
    "39398"
  ],
  "./prism-xojo": [
    "22449",
    "96077"
  ],
  "./prism-lua": [
    "66841",
    "79746"
  ],
  "./prism-antlr4": [
    "44852",
    "32520"
  ],
  "./prism-gcode": [
    "28407",
    "53662"
  ],
  "./prism-nix.js": [
    "58704",
    "40229"
  ],
  "./prism-gml.min.js": [
    "81813",
    "90139"
  ],
  "./prism-llvm": [
    "85153",
    "24043"
  ],
  "./prism-smarty.min.js": [
    "58794",
    "80572"
  ],
  "./prism-javastacktrace.min": [
    "39837",
    "74718"
  ],
  "./prism-ejs": [
    "70060",
    "41221"
  ],
  "./prism-factor": [
    "50171",
    "9429"
  ],
  "./prism-pug.min": [
    "63138",
    "66940"
  ],
  "./prism-sas.min": [
    "8920",
    "93182"
  ],
  "./prism-turtle.min.js": [
    "10034",
    "21282"
  ],
  "./prism-makefile.min": [
    "75151",
    "71700"
  ],
  "./prism-http.js": [
    "50057",
    "36496"
  ],
  "./prism-diff.js": [
    "40728",
    "74072"
  ],
  "./prism-t4-cs": [
    "20601",
    "93528"
  ],
  "./prism-bison.min": [
    "41248",
    "26090"
  ],
  "./prism-vhdl.min": [
    "377",
    "87637"
  ],
  "./prism-parigp.js": [
    "47511",
    "8142"
  ],
  "./prism-ini": [
    "29525",
    "98786"
  ],
  "./prism-xojo.min": [
    "37315",
    "74884"
  ],
  "./prism-handlebars.min": [
    "34329",
    "34345"
  ],
  "./prism-stylus.js": [
    "24906",
    "24102"
  ],
  "./prism-abnf.min.js": [
    "48121",
    "88030"
  ],
  "./prism-opencl.min.js": [
    "52818",
    "20397"
  ],
  "./prism-csp.min.js": [
    "12926",
    "66124"
  ],
  "./prism-brainfuck": [
    "15827",
    "37929"
  ],
  "./prism-livescript.min": [
    "41163",
    "93324"
  ],
  "./prism-agda": [
    "47231",
    "89766"
  ],
  "./prism-kotlin.js": [
    "32334",
    "32657"
  ],
  "./prism-racket.min": [
    "87382",
    "66000"
  ],
  "./prism-lisp.min": [
    "87770",
    "75322"
  ],
  "./prism-jsdoc.min.js": [
    "27472",
    "41607"
  ],
  "./prism-nsis.js": [
    "74876",
    "8134"
  ],
  "./prism-ichigojam.min.js": [
    "54111",
    "55541"
  ],
  "./prism-ada.min": [
    "92497",
    "23623"
  ],
  "./prism-xquery.min": [
    "25558",
    "88907"
  ],
  "./prism-vim.min.js": [
    "34836",
    "39764"
  ],
  "./prism-dax.min": [
    "19486",
    "86622"
  ],
  "./prism-json5.min.js": [
    "54001",
    "35908"
  ],
  "./prism-dart.min.js": [
    "80974",
    "30464"
  ],
  "./prism-latex": [
    "90319",
    "12918"
  ],
  "./prism-editorconfig.min.js": [
    "41880",
    "71257"
  ],
  "./prism-cmake.min.js": [
    "79278",
    "15937"
  ],
  "./prism-hsts.js": [
    "17786",
    "33831"
  ],
  "./prism-pure": [
    "9753",
    "80219"
  ],
  "./prism-perl.js": [
    "20288",
    "67458"
  ],
  "./prism-basic.min": [
    "47098",
    "4162"
  ],
  "./prism-cmake.js": [
    "44225",
    "93564"
  ],
  "./prism-clike.min.js": [
    "58080",
    "56975"
  ],
  "./prism-clojure.min": [
    "14821",
    "99210"
  ],
  "./prism-cpp": [
    "2731",
    "49505"
  ],
  "./prism-aspnet.min.js": [
    "54780",
    "66550"
  ],
  "./prism-soy.min.js": [
    "95210",
    "73889"
  ],
  "./prism-livescript.js": [
    "76347",
    "731"
  ],
  "./prism-sql.min.js": [
    "82720",
    "40533"
  ],
  "./prism-ejs.js": [
    "70060",
    "41221"
  ],
  "./prism-css-extras.js": [
    "80871",
    "37629"
  ],
  "./prism-excel-formula": [
    "51039",
    "6672"
  ],
  "./prism-moonscript.js": [
    "61899",
    "36279"
  ],
  "./prism-fsharp.js": [
    "75045",
    "47170"
  ],
  "./prism-haml.js": [
    "39181",
    "78933"
  ],
  "./prism-processing": [
    "97353",
    "82384"
  ],
  "./prism-toml": [
    "9930",
    "4352"
  ],
  "./prism-verilog.min.js": [
    "93937",
    "42819"
  ],
  "./prism-sql": [
    "35266",
    "43168"
  ],
  "./prism-j": [
    "18848",
    "21953"
  ],
  "./prism-al.min.js": [
    "47347",
    "86531"
  ],
  "./prism-concurnas.min.js": [
    "2836",
    "79231"
  ],
  "./prism-erlang.min": [
    "39540",
    "99769"
  ],
  "./prism-q.js": [
    "82939",
    "24162"
  ],
  "./prism-lolcode.min": [
    "10076",
    "7120"
  ],
  "./prism-c.min.js": [
    "36551",
    "44154"
  ],
  "./prism-haxe.min": [
    "40714",
    "6172"
  ],
  "./prism-hcl.js": [
    "24677",
    "67986"
  ],
  "./prism-qml": [
    "84891",
    "66828"
  ],
  "./prism-icon": [
    "54263",
    "78825"
  ],
  "./prism-bison.min.js": [
    "41248",
    "26090"
  ],
  "./prism-markup.min": [
    "74060",
    "89629"
  ],
  "./prism-matlab.min.js": [
    "55354",
    "43494"
  ],
  "./prism-nginx.min": [
    "49503",
    "88571"
  ],
  "./prism-nix.min": [
    "34232",
    "14785"
  ],
  "./prism-phpdoc.min.js": [
    "49724",
    "6116"
  ],
  "./prism-ocaml.min.js": [
    "37610",
    "14454"
  ],
  "./prism-peoplecode.js": [
    "74984",
    "13297"
  ],
  "./prism-sparql": [
    "71327",
    "55902"
  ],
  "./prism-wiki.min.js": [
    "83409",
    "86860"
  ],
  "./prism-scheme.min": [
    "25781",
    "20144"
  ],
  "./prism-arduino": [
    "51849",
    "18638"
  ],
  "./prism-tt2.min": [
    "89366",
    "18064"
  ],
  "./prism-nginx": [
    "33436",
    "63070"
  ],
  "./prism-diff.min.js": [
    "72734",
    "44859"
  ],
  "./prism-abap.js": [
    "86405",
    "54861"
  ],
  "./prism-javadoc": [
    "52008",
    "33595"
  ],
  "./prism-typescript.min": [
    "76456",
    "99553"
  ],
  "./prism-pure.min.js": [
    "44697",
    "89340"
  ],
  "./prism-gdscript": [
    "65276",
    "20849"
  ],
  "./prism-js-templates.min": [
    "3908",
    "28925"
  ],
  "./prism-sas.min.js": [
    "8920",
    "93182"
  ],
  "./prism-twig.js": [
    "71429",
    "61086"
  ],
  "./prism-php-extras.min": [
    "66200",
    "90389"
  ],
  "./prism-dart.js": [
    "57065",
    "2213"
  ],
  "./prism-json5": [
    "22444",
    "93609"
  ],
  "./prism-warpscript.js": [
    "10008",
    "73817"
  ],
  "./prism-core.js": [
    "28325",
    "75123"
  ],
  "./prism-puppet": [
    "24319",
    "78308"
  ],
  "./prism-liquid.js": [
    "150",
    "16695"
  ],
  "./prism-basic.js": [
    "94446",
    "83977"
  ],
  "./prism-glsl": [
    "79812",
    "44139"
  ],
  "./prism-nasm": [
    "52353",
    "88160"
  ],
  "./prism-ftl.min": [
    "76831",
    "40722"
  ],
  "./prism-sass.min": [
    "23683",
    "14693"
  ],
  "./prism-pascaligo": [
    "54332",
    "32472"
  ],
  "./prism-powershell.min": [
    "77424",
    "47002"
  ],
  "./prism-shell-session": [
    "42963",
    "6905"
  ],
  "./prism-apacheconf.min": [
    "24242",
    "85450"
  ],
  "./prism-xojo.js": [
    "22449",
    "96077"
  ],
  "./prism-ftl.min.js": [
    "76831",
    "40722"
  ],
  "./prism-css.js": [
    "15251",
    "94325"
  ],
  "./prism-csp.min": [
    "12926",
    "66124"
  ],
  "./prism-elm.min": [
    "84269",
    "93712"
  ],
  "./prism-q": [
    "82939",
    "24162"
  ],
  "./prism-qml.js": [
    "84891",
    "66828"
  ],
  "./prism-rest.min.js": [
    "22369",
    "41130"
  ],
  "./prism-stylus.min": [
    "72660",
    "295"
  ],
  "./prism-cpp.js": [
    "2731",
    "49505"
  ],
  "./prism-factor.min.js": [
    "16302",
    "12501"
  ],
  "./prism-dns-zone-file.min.js": [
    "67659",
    "67666"
  ],
  "./prism-vim.js": [
    "34438",
    "35558"
  ],
  "./prism-hlsl.min": [
    "62058",
    "91022"
  ],
  "./prism-agda.min": [
    "14552",
    "90273"
  ],
  "./prism-vhdl.min.js": [
    "377",
    "87637"
  ],
  "./prism-pug.min.js": [
    "63138",
    "66940"
  ],
  "./prism-solution-file.js": [
    "37485",
    "81711"
  ],
  "./prism-latte.js": [
    "87442",
    "19690"
  ],
  "./prism-parser": [
    "40780",
    "3999"
  ],
  "./prism-smarty.min": [
    "58794",
    "80572"
  ],
  "./prism-csharp.min": [
    "53229",
    "5230"
  ],
  "./prism-typescript.js": [
    "96836",
    "35468"
  ],
  "./prism-php-extras.min.js": [
    "66200",
    "90389"
  ],
  "./prism-inform7.min.js": [
    "26293",
    "47172"
  ],
  "./prism-markup-templating": [
    "96854",
    "64465"
  ],
  "./prism-csharp": [
    "79016",
    "51738"
  ],
  "./prism-properties.min.js": [
    "31623",
    "41912"
  ],
  "./prism-monkey.min": [
    "7259",
    "382"
  ],
  "./prism-hlsl": [
    "5578",
    "96730"
  ],
  "./prism-shell-session.min.js": [
    "98863",
    "23319"
  ],
  "./prism-arduino.min.js": [
    "71335",
    "22072"
  ],
  "./prism-xeora.js": [
    "10504",
    "12978"
  ],
  "./prism-tsx.js": [
    "21029",
    "90421"
  ],
  "./prism-firestore-security-rules": [
    "6634",
    "8831"
  ],
  "./prism-ftl.js": [
    "72778",
    "10499"
  ],
  "./prism-abap.min.js": [
    "7062",
    "1041"
  ],
  "./prism-hsts": [
    "17786",
    "33831"
  ],
  "./prism-brightscript.js": [
    "76366",
    "20321"
  ],
  "./prism-nand2tetris-hdl.min": [
    "48974",
    "93915"
  ],
  "./prism-scheme.js": [
    "51412",
    "18464"
  ],
  "./prism-etlua": [
    "79958",
    "31746"
  ],
  "./prism-j.js": [
    "18848",
    "21953"
  ],
  "./prism-solidity.min.js": [
    "3648",
    "87297"
  ],
  "./prism-jq.min": [
    "92771",
    "84901"
  ],
  "./prism-core.min": [
    "2251",
    "32566"
  ],
  "./prism-django.js": [
    "54409",
    "44068"
  ],
  "./prism-gcode.js": [
    "28407",
    "53662"
  ],
  "./prism-markdown.min.js": [
    "90047",
    "23967"
  ],
  "./prism-powerquery.js": [
    "63887",
    "4722"
  ],
  "./prism-smali.min": [
    "51406",
    "9491"
  ],
  "./prism-aql.min.js": [
    "29846",
    "86023"
  ],
  "./prism-io": [
    "48942",
    "88492"
  ],
  "./prism-js-templates.min.js": [
    "3908",
    "28925"
  ],
  "./prism-markup-templating.min": [
    "48929",
    "92827"
  ],
  "./prism-lua.min": [
    "63047",
    "60107"
  ],
  "./prism-keyman.min.js": [
    "51064",
    "22076"
  ],
  "./prism-zig.min.js": [
    "87975",
    "54828"
  ],
  "./prism-mizar.min": [
    "38654",
    "89699"
  ],
  "./prism-swift": [
    "90874",
    "4323"
  ],
  "./prism-mel.min.js": [
    "52357",
    "89803"
  ],
  "./prism-xeora.min.js": [
    "30646",
    "56739"
  ],
  "./prism-diff": [
    "40728",
    "74072"
  ],
  "./prism-json.js": [
    "55394",
    "33354"
  ],
  "./prism-gherkin.js": [
    "49472",
    "12194"
  ],
  "./prism-graphql.js": [
    "17117",
    "77945"
  ],
  "./prism-q.min": [
    "32055",
    "16216"
  ],
  "./prism-rip.min.js": [
    "44538",
    "43966"
  ],
  "./prism-nix.min.js": [
    "34232",
    "14785"
  ],
  "./prism-properties.min": [
    "31623",
    "41912"
  ],
  "./prism-twig": [
    "71429",
    "61086"
  ],
  "./prism-batch.js": [
    "53292",
    "91747"
  ],
  "./prism-arff": [
    "73253",
    "12560"
  ],
  "./prism-docker.js": [
    "77158",
    "91207"
  ],
  "./prism-visual-basic.min": [
    "67964",
    "30428"
  ],
  "./prism-xquery": [
    "19938",
    "95866"
  ],
  "./prism-tsx": [
    "21029",
    "90421"
  ],
  "./prism-java.js": [
    "52503",
    "2457"
  ],
  "./prism-css-extras.min": [
    "61710",
    "11230"
  ],
  "./prism-applescript.min.js": [
    "39943",
    "60556"
  ],
  "./prism-nasm.min": [
    "10603",
    "10077"
  ],
  "./prism-llvm.min": [
    "82932",
    "38571"
  ],
  "./prism-oz.min": [
    "87553",
    "14158"
  ],
  "./prism-scheme": [
    "51412",
    "18464"
  ],
  "./prism-gml": [
    "71828",
    "82567"
  ],
  "./prism-agda.js": [
    "47231",
    "89766"
  ],
  "./prism-pcaxis.min": [
    "55863",
    "19234"
  ],
  "./prism-autohotkey.min": [
    "531",
    "84459"
  ],
  "./prism-visual-basic.min.js": [
    "67964",
    "30428"
  ],
  "./prism-tap.min.js": [
    "85599",
    "5685"
  ],
  "./prism-visual-basic.js": [
    "83082",
    "19428"
  ],
  "./prism-pascal.min": [
    "53484",
    "40166"
  ],
  "./prism-asm6502.min.js": [
    "68409",
    "74101"
  ],
  "./prism-ini.min.js": [
    "19475",
    "55771"
  ],
  "./prism-erb.min.js": [
    "83000",
    "52863"
  ],
  "./prism-julia.min": [
    "82580",
    "19582"
  ],
  "./prism-julia.js": [
    "56543",
    "17717"
  ],
  "./prism-docker": [
    "77158",
    "91207"
  ],
  "./prism-regex.js": [
    "49299",
    "35901"
  ],
  "./prism-dhall.min.js": [
    "87981",
    "42239"
  ],
  "./prism-nand2tetris-hdl.min.js": [
    "48974",
    "93915"
  ],
  "./prism-javastacktrace": [
    "81454",
    "5848"
  ],
  "./prism-inform7.min": [
    "26293",
    "47172"
  ],
  "./prism-turtle": [
    "68092",
    "6756"
  ],
  "./prism-llvm.js": [
    "85153",
    "24043"
  ],
  "./prism-sas": [
    "71384",
    "73088"
  ],
  "./prism-powershell": [
    "86862",
    "18687"
  ],
  "./prism-lua.min.js": [
    "63047",
    "60107"
  ],
  "./prism-scss.min.js": [
    "9578",
    "44405"
  ],
  "./prism-c.min": [
    "36551",
    "44154"
  ],
  "./prism-matlab.js": [
    "61169",
    "75513"
  ],
  "./prism-visual-basic": [
    "83082",
    "19428"
  ],
  "./prism-ejs.min.js": [
    "65823",
    "5123"
  ],
  "./prism-concurnas.js": [
    "29467",
    "53664"
  ],
  "./prism-factor.min": [
    "16302",
    "12501"
  ],
  "./prism-pascaligo.min": [
    "68000",
    "98536"
  ],
  "./prism-arff.min": [
    "13955",
    "39120"
  ],
  "./prism-yang": [
    "2982",
    "11370"
  ],
  "./prism-gcode.min.js": [
    "9303",
    "75618"
  ],
  "./prism-puppet.js": [
    "24319",
    "78308"
  ],
  "./prism-soy.min": [
    "95210",
    "73889"
  ],
  "./prism-r.js": [
    "54803",
    "25073"
  ],
  "./prism-agda.min.js": [
    "14552",
    "90273"
  ],
  "./prism-apacheconf": [
    "77533",
    "97885"
  ],
  "./prism-solution-file.min.js": [
    "44863",
    "54871"
  ],
  "./prism-clike": [
    "35433",
    "55728"
  ],
  "./prism-crystal": [
    "18980",
    "5176"
  ],
  "./prism-go.min": [
    "51970",
    "14897"
  ],
  "./prism-dax.min.js": [
    "19486",
    "86622"
  ],
  "./prism-lilypond.js": [
    "61719",
    "35948"
  ],
  "./prism-ini.js": [
    "29525",
    "98786"
  ],
  "./prism-css-extras": [
    "80871",
    "37629"
  ],
  "./prism-pcaxis.js": [
    "52892",
    "43769"
  ],
  "./prism-latex.min.js": [
    "99119",
    "15719"
  ],
  "./prism-pug": [
    "93381",
    "66502"
  ],
  "./prism-csharp.min.js": [
    "53229",
    "5230"
  ],
  "./prism-css.min.js": [
    "12247",
    "2677"
  ],
  "./prism-moonscript.min": [
    "65298",
    "83281"
  ],
  "./prism-arduino.min": [
    "71335",
    "22072"
  ],
  "./prism-solidity": [
    "30893",
    "37846"
  ],
  "./prism-protobuf": [
    "37345",
    "51946"
  ],
  "./prism-less.min": [
    "64006",
    "97343"
  ],
  "./prism-q.min.js": [
    "32055",
    "16216"
  ],
  "./prism-bbcode.min.js": [
    "22661",
    "5917"
  ],
  "./prism-pascal.js": [
    "13210",
    "42708"
  ],
  "./prism-yang.js": [
    "2982",
    "11370"
  ],
  "./prism-t4-cs.min": [
    "73233",
    "88588"
  ],
  "./prism-docker.min.js": [
    "74280",
    "54018"
  ],
  "./prism-go.js": [
    "27046",
    "81171"
  ],
  "./prism-concurnas.min": [
    "2836",
    "79231"
  ],
  "./prism-javadoc.min.js": [
    "78792",
    "31926"
  ],
  "./prism-tcl.min.js": [
    "96195",
    "70330"
  ],
  "./prism-unrealscript.min": [
    "79133",
    "96072"
  ],
  "./prism-eiffel": [
    "59979",
    "39438"
  ],
  "./prism-matlab.min": [
    "55354",
    "43494"
  ],
  "./prism-brightscript": [
    "76366",
    "20321"
  ],
  "./prism-markdown.min": [
    "90047",
    "23967"
  ],
  "./prism-bash.min.js": [
    "87013",
    "9258"
  ],
  "./prism-nsis": [
    "74876",
    "8134"
  ],
  "./prism-bbcode": [
    "46428",
    "89205"
  ],
  "./prism-less.js": [
    "37802",
    "12649"
  ],
  "./prism-reason.js": [
    "28439",
    "45019"
  ],
  "./prism-iecst.min": [
    "17238",
    "78468"
  ],
  "./prism-prolog": [
    "43932",
    "1000"
  ],
  "./prism-t4-templating": [
    "89239",
    "76039"
  ],
  "./prism-vim": [
    "34438",
    "35558"
  ],
  "./prism-javadoclike": [
    "54884",
    "19205"
  ],
  "./prism-fortran.min.js": [
    "70975",
    "11095"
  ],
  "./prism-groovy": [
    "40485",
    "80555"
  ],
  "./prism-t4-templating.min.js": [
    "94413",
    "33557"
  ],
  "./prism-mel.min": [
    "52357",
    "89803"
  ],
  "./prism-nginx.min.js": [
    "49503",
    "88571"
  ],
  "./prism-gdscript.min": [
    "20563",
    "18639"
  ],
  "./prism-nim.js": [
    "35743",
    "98182"
  ],
  "./prism-javascript.min.js": [
    "30235",
    "99393"
  ],
  "./prism-inform7.js": [
    "56521",
    "21580"
  ],
  "./prism-solidity.min": [
    "3648",
    "87297"
  ],
  "./prism-xeora.min": [
    "30646",
    "56739"
  ],
  "./prism-scala.min": [
    "57239",
    "57261"
  ],
  "./prism-gdscript.min.js": [
    "20563",
    "18639"
  ],
  "./prism-gherkin.min": [
    "19876",
    "53494"
  ],
  "./prism-nand2tetris-hdl": [
    "80454",
    "1085"
  ],
  "./prism-parser.min": [
    "97410",
    "19780"
  ],
  "./prism-git.js": [
    "79787",
    "71172"
  ],
  "./prism-vbnet": [
    "65398",
    "2225"
  ],
  "./prism-basic.min.js": [
    "47098",
    "4162"
  ],
  "./prism-cmake.min": [
    "79278",
    "15937"
  ],
  "./prism-haskell.js": [
    "51797",
    "75981"
  ],
  "./prism-brightscript.min.js": [
    "39455",
    "71161"
  ],
  "./prism-django": [
    "54409",
    "44068"
  ],
  "./prism-llvm.min.js": [
    "82932",
    "38571"
  ],
  "./prism-autohotkey.js": [
    "92776",
    "52565"
  ],
  "./prism-objectivec.min": [
    "51637",
    "77344"
  ],
  "./prism-powerquery": [
    "63887",
    "4722"
  ],
  "./prism-solidity.js": [
    "30893",
    "37846"
  ],
  "./prism-renpy.js": [
    "38512",
    "17075"
  ],
  "./prism-ignore.js": [
    "10880",
    "23130"
  ],
  "./prism-mizar.js": [
    "15101",
    "44213"
  ],
  "./prism-elm": [
    "75041",
    "56203"
  ],
  "./prism-reason.min": [
    "47788",
    "69307"
  ],
  "./prism-perl.min.js": [
    "93972",
    "53008"
  ],
  "./prism-elixir.min": [
    "43045",
    "48553"
  ],
  "./prism-textile": [
    "60075",
    "25062"
  ],
  "./prism-vala": [
    "30035",
    "60795"
  ],
  "./prism-unrealscript": [
    "10196",
    "23056"
  ],
  "./prism-jsdoc": [
    "68915",
    "52939"
  ],
  "./prism-jsonp.js": [
    "64488",
    "72886"
  ],
  "./prism-erlang.min.js": [
    "39540",
    "99769"
  ],
  "./prism-n1ql.js": [
    "55949",
    "69931"
  ],
  "./prism-perl": [
    "20288",
    "67458"
  ],
  "./prism-iecst.js": [
    "55689",
    "32442"
  ],
  "./prism-qore.js": [
    "94933",
    "72115"
  ],
  "./prism-csp": [
    "4412",
    "56497"
  ],
  "./prism-gdscript.js": [
    "65276",
    "20849"
  ],
  "./prism-roboconf": [
    "94840",
    "37335"
  ],
  "./prism-javastacktrace.min.js": [
    "39837",
    "74718"
  ],
  "./prism-protobuf.min": [
    "98250",
    "22271"
  ],
  "./prism-prolog.min": [
    "32517",
    "39544"
  ],
  "./prism-dns-zone-file": [
    "68483",
    "32405"
  ],
  "./prism-latex.min": [
    "99119",
    "15719"
  ],
  "./prism-t4-templating.js": [
    "89239",
    "76039"
  ],
  "./prism-cpp.min.js": [
    "54132",
    "66719"
  ],
  "./prism-rust.min": [
    "60983",
    "44995"
  ],
  "./prism-robotframework.min.js": [
    "9611",
    "51331"
  ],
  "./prism-glsl.js": [
    "79812",
    "44139"
  ],
  "./prism-json.min": [
    "8674",
    "88519"
  ],
  "./prism-parigp.min": [
    "90575",
    "67433"
  ],
  "./prism-csp.js": [
    "4412",
    "56497"
  ],
  "./prism-bnf.min.js": [
    "86751",
    "39061"
  ],
  "./prism-cil.js": [
    "4677",
    "43154"
  ],
  "./prism-renpy.min.js": [
    "68169",
    "21303"
  ],
  "./prism-haskell.min": [
    "12199",
    "3321"
  ],
  "./prism-nsis.min.js": [
    "68617",
    "38225"
  ],
  "./prism-makefile.js": [
    "48443",
    "31442"
  ],
  "./prism-tsx.min": [
    "16336",
    "78631"
  ],
  "./prism-css-extras.min.js": [
    "61710",
    "11230"
  ],
  "./prism-elixir": [
    "68805",
    "41693"
  ],
  "./prism-json5.js": [
    "22444",
    "93609"
  ],
  "./prism-velocity": [
    "70981",
    "36295"
  ],
  "./prism-moonscript": [
    "61899",
    "36279"
  ],
  "./prism-clojure.min.js": [
    "14821",
    "99210"
  ],
  "./prism-asciidoc.min.js": [
    "55692",
    "68924"
  ],
  "./prism-diff.min": [
    "72734",
    "44859"
  ],
  "./prism-splunk-spl": [
    "612",
    "65407"
  ],
  "./prism-tsx.min.js": [
    "16336",
    "78631"
  ],
  "./prism-cmake": [
    "44225",
    "93564"
  ],
  "./prism-elm.min.js": [
    "84269",
    "93712"
  ],
  "./prism-javadoclike.min": [
    "46847",
    "23721"
  ],
  "./prism-go.min.js": [
    "51970",
    "14897"
  ],
  "./prism-js-extras.min": [
    "49273",
    "3490"
  ],
  "./prism-jsstacktrace": [
    "81917",
    "4621"
  ],
  "./prism-ebnf": [
    "68232",
    "11167"
  ],
  "./prism-http": [
    "50057",
    "36496"
  ],
  "./prism-glsl.min.js": [
    "58575",
    "19426"
  ],
  "./prism-git.min": [
    "93530",
    "3793"
  ],
  "./prism-applescript.js": [
    "31093",
    "16512"
  ],
  "./prism-abnf.js": [
    "68758",
    "84257"
  ],
  "./prism-processing.js": [
    "97353",
    "82384"
  ],
  "./prism-prolog.js": [
    "43932",
    "1000"
  ],
  "./prism-firestore-security-rules.js": [
    "6634",
    "8831"
  ],
  "./prism-java.min": [
    "17706",
    "87366"
  ],
  "./prism-neon.min": [
    "98832",
    "55789"
  ],
  "./prism-cil.min.js": [
    "54002",
    "74681"
  ],
  "./prism-textile.js": [
    "60075",
    "25062"
  ],
  "./prism-t4-vb.js": [
    "16241",
    "85132"
  ],
  "./prism-verilog.min": [
    "93937",
    "42819"
  ],
  "./prism-erlang": [
    "8956",
    "66363"
  ],
  "./prism-io.min.js": [
    "93154",
    "41740"
  ],
  "./prism-xeora": [
    "10504",
    "12978"
  ],
  "./prism-asm6502.min": [
    "68409",
    "74101"
  ],
  "./prism-arff.js": [
    "73253",
    "12560"
  ],
  "./prism-abap.min": [
    "7062",
    "1041"
  ],
  "./prism-glsl.min": [
    "58575",
    "19426"
  ],
  "./prism-nand2tetris-hdl.js": [
    "80454",
    "1085"
  ],
  "./prism-jsstacktrace.min.js": [
    "68152",
    "96705"
  ],
  "./prism-cypher": [
    "30258",
    "83325"
  ],
  "./prism-velocity.min": [
    "76627",
    "59264"
  ],
  "./prism-java": [
    "52503",
    "2457"
  ],
  "./prism-regex": [
    "49299",
    "35901"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, 7 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 62852;
module.exports = webpackAsyncContext;
